/*
* Select filters
*/

$.fn.SelectFilters = function() {
  let self = this;
  self.list = $('<ul>');

  self.el = {
    container: self.find('.map-filters'),
    select: self.find('select'),
    options: self.find('option'),
  };

  /* Item clicked */
  self.clicked = function() {
    self.list.find('li').removeClass('selected');
    $(this).addClass('selected');
    self.el.select.val($(this).data('value')).trigger('change');
  };

  return function() {
    /* Default values */
    let defaultValues = $('.map-chrome').data('default');
    if (defaultValues) {
      defaultValues = defaultValues.split(',');
    }

    /* Create lists */
    self.el.options.each(function() {
      let value = $(this).val();
      let option = $('<li>').data('value', $(this).val()).text($(this).text());
      option.on('click', self.clicked);
      self.list.append(option);
      if (defaultValues && defaultValues.indexOf(value) !== -1) {
        setTimeout(function() {
          option.click();
        }, 500);
      }
    });
    self.list.find('li:eq(0)').addClass('selected');
    self.el.container.prepend(self.list);
    return self;
  }();
};
